import BottomNavigation from "component/BottomNavigation/BottomNavigation";
import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import '../Home.scss';

const AppLayout: React.FC = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const getTitle = () => {
    if (location.pathname.startsWith("/contracts/")) return "Kontrak Detail";
    if (location.pathname.startsWith("/contracts")) return "Kontrak";
    if (location.pathname.startsWith("/manage-store/")) return "Detail Toko";
    if (location.pathname.startsWith("/manage-store")) return "Kelola Toko";
    if (location.pathname.startsWith("/profile/edit")) return "Edit Profil";
    if (location.pathname.startsWith("/profile/faq")) return "FAQ";
    if (location.pathname.startsWith("/profile")) return "Profil";
    return "";
  };

  const showBack =
    location.pathname.includes("/edit") ||
    location.pathname.includes("/contracts/") ||
    location.pathname.includes("/manage-store/") ||
    location.pathname.includes("/faq");

  const mainNavigation =
    location.pathname == "/contracts" ||
    location.pathname == "/manage-store" ||
    location.pathname == "/profile";

  console.log(mainNavigation)

  return (
    <div className="min-vh-100 pb-5" style={{background:'white'}}>

      <div
        className="bg-ps-primary text-white px-3 d-flex align-items-center"
        style={{ height: "70px" }}
      >
        {showBack && (
          <button
            className="btn text-white p-0 me-3"
            style={{ fontSize: 22, lineHeight: 1 }}
            onClick={() => navigate(-1)}
          >
            ←
          </button>
        )}

        <h5 className="fw-bold m-0">{getTitle()}</h5>
      </div>

      <div>
        <Outlet />
      </div>
      {
        mainNavigation &&
        <BottomNavigation />
      }
    </div>
  );
};

export default AppLayout;